const twoDigitsFormat = (number: number): string => {
  if (number < 10) return `0${number}`
  else return number.toString()
}

export default twoDigitsFormat
